{
  "slug": "iq-distribution",
  "title": "IQ Distribution Explained",
  "description": "How the bell curve, mean, standard deviation, tails, and real norms relate to IQ.",
  "category": "IQ statistics",
  "sections": [
    {
      "heading": "Meaning",
      "paragraphs": [
        "How the bell curve, mean, standard deviation, tails, and real norms relate to IQ.",
        "Interpretation depends on population, instrument, edition, year, sampling, language, and method."
      ]
    },
    {
      "heading": "Read charts carefully",
      "paragraphs": [
        "Check representativeness, uncertainty, exclusions, and whether values were measured or estimated. Decimal-heavy rankings are not automatically precise.",
        "Group averages have substantial overlap and cannot determine an individual."
      ]
    },
    {
      "heading": "Responsible conclusion",
      "paragraphs": [
        "Prefer transparent primary datasets and intervals. Avoid causal claims from correlation alone.",
        "For an individual, use appropriate age norms and technical documentation."
      ]
    }
  ],
  "related": ["what-is-the-average-iq", "how-is-iq-measured", "iq-score-ranges-explained"],
  "sources": [
    {
      "label": "OECD — PISA data and methodology",
      "url": "https://www.oecd.org/pisa/data/"
    }
  ],
  "faqs": [],
  "summary": "How the bell curve, mean, standard deviation, tails, and real norms relate to IQ. Content reviewed 18 July 2026."
}
